import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-navy px-4 pb-6 pt-5 text-center md:px-10 md:pb-7 md:pt-5" data-id="element-71" data-mp="28u4ncn43lelf">
      <h1 className="font-heading text-[26px] font-extrabold uppercase leading-[1.06] tracking-[-0.3px] text-white md:text-[38px]" data-id="element-72" data-mp="28vzbsbekvou9">
        The complete activity system for <span className="text-brand" data-id="element-73" data-mp="30ksqu5t8uw29">speech-language professionals.</span>
      </h1>
      <p className="mx-auto mt-3 max-w-[560px] text-[14px] leading-[1.35] text-white md:text-[16px]" data-id="element-74" data-mp="2msuqajdlm8hp">
        Stop rebuilding therapy materials before every session. Access articulation activities, receptive and
        expressive language exercises, social communication resources, minimal pairs cards, therapy games, home
        practice materials, and professional tracking forms — all organized in one ready-to-use collection.
      </p>
      <p className="mt-2 font-heading text-[12px] font-bold uppercase leading-tight text-gold md:text-[14px]" data-id="element-75" data-mp="2fd5vxlzgb7fm">
        Less time preparing. More organized therapy sessions.
      </p>

      <div className="mx-auto mt-3 max-w-[300px]" data-id="element-76" data-mp="2p6mrovj5ewlx">
        <ProductImage data-id="element-77" data-mp="2ke3fo30409j8" />
      </div>

      <div className="mt-3" data-id="element-78" data-mp="2kd22nszj9cyv">
        <CtaButton mode="scroll" data-id="element-79" data-mp="2kcs8dt7ggjnd">Yes! I want my sessions ready</CtaButton>
      </div>
      <p className="mt-3 font-heading text-[11px] font-bold uppercase tracking-[0.12em] text-white md:text-[12px]" data-id="element-80" data-mp="2z5m1wijkb0b1">
        Get your therapy sessions ready today!
      </p>
      <p className="mx-auto mt-1 max-w-[440px] font-heading text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-81" data-mp="382weq8c12xi2">
        {guaranteeEnabled && <>
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-brand" aria-hidden data-id="element-82" data-mp="1dpdaygremiob" />
            7-day money-back guarantee •{' '}
          </>}
        4 volumes + 4 free bonuses
      </p>
    </header>;
}